import { callGet} from "./index";
import {
  Country,
  County,
  CountyType,
  CountyTypeJSON,
  CourtType,
  CourtTypeJSON,
  State,
} from "../models/Geography";

export class Geographies {
  async fetchCountries(): Promise<Country[] | undefined> {
    try {
      const path = "geographies/countries";
      const response = await callGet(path, true);
      const countries: Country[] = [];
      response?.data?.forEach((country: any) => {
        countries.push(Country.fromJSON(country));
      });

      return countries;
    } catch (error) {
      this.handleError(error);
    }
    return undefined;
  }

  async fetchCountry(countryId: number): Promise<Country | undefined> {
    try {
      const path =  `geographies/countries/${countryId}`;
      const response = await callGet(path, true);
      const country: Country = Country.fromJSON(response?.data);
      return country;
    } catch (error) {
      this.handleError(error);
    }
    return undefined;
  }

  async fetchCountyTypes(): Promise<CountyType[] | undefined> {
    try {
      const path =  "county-types";
      const response = await callGet(path, true);
      return response?.data?.map((json: CountyTypeJSON) =>
        CountyType.fromJSON(json)
      );
    } catch (error) {
      console.error(error, "getCountyTypes error");
    }
  }

  async fetchCourtTypes(): Promise<CourtType[] | undefined> {
    try {
      const path =  "court-types";
      const response = await callGet(path, true);
      return response?.data?.map((json: CourtTypeJSON) =>
        CourtType.fromJSON(json)
      );
    } catch (error) {
      console.error(error, "getCourtTypes error");
    }
  }

  async fetchStates(): Promise<State[] | undefined> {
    try {
      const fullPath = "geographies/states";
      const response = await callGet(fullPath, true);
      const states: State[] = [];
      response?.data?.forEach((state: any) => {
        states.push(State.fromJSON(state));
      });

      return states.sort(function (a: State, b: State) {
        if (!a || !b) {
          return -1
        }
        if (a.name < b.name) {
          return -1;
        }
        if (a.name > b.name) {
          return 1;
        }
        return 0;
      });
    } catch (error) {
      this.handleError(error);
    }
    return undefined;
  }

  async fetchState(stateId: number): Promise<State | undefined> {
    try {
      const fullPath =  "geographies/state/" + stateId;
      const response = await callGet(fullPath, true);
      const state: State = State.fromJSON(response?.data);
      return state;
    } catch (error) {
      this.handleError(error);
    }
    return undefined;
  }

  async fetchCounties(stateId: number): Promise<County[] | undefined> {
    try {
      const fullPath =  "geographies/state/" + stateId + "/counties";
      const response = await callGet(fullPath, true);

      const counties: County[] = [];
      response?.data?.forEach((county: any) => {
        counties.push(County.fromJSON(county));
      });

      return counties.sort(function (a: County, b: County) {
        if (!a || !b) {
          return -1
        }
        if (a.name < b.name) {
          return -1;
        }
        if (a.name > b.name) {
          return 1;
        }
        return 0;
      });
    } catch (error) {
      this.handleError(error);
    }
    return undefined;
  }

  async fetchCounty(countyId: number): Promise<County | undefined> {
    try {
      const fullPath =  "geographies/county/" + countyId;
      const response = await callGet(fullPath, true);
      const county = County.fromJSON(response?.data);
      return county;
    } catch (error) {
      this.handleError(error);
    }
    return undefined;
  }

  handleError(error: any): void {
    if ((error as Error)?.message === "no response.data") {
      console.error(error, false);
    } else {
      console.error(error as Error);
    }
  }
}
